module.exports = __webpack_public_path__ + "img/desktop-hand-pointer.48c36bb7.svg";